// extracted by mini-css-extract-plugin
export default {"root":"Login_root__Mv9xp","wrapper":"Login_wrapper__QitVN","wrapper_img":"Login_wrapper_img__aGVPi","main__wrapper":"Login_main__wrapper__9jtQ9"};